const Login = () => import('../components/views/Login/index');
const Home = () => import('../components/views/Home/index');
// const NotFound = () => import('../components/global/NotFound');
const ForgotPassword = () => import('../components/views/ForgotPassword/index');
const ForgotPasswordSent = () => import('../components/views/ForgotPasswordSent/index');
const SetNewPassword = () => import('../components/views/SetNewPassword/index');
const NewPasswordSuccess = () => import('../components/views/NewPasswordSuccess/index');
const Dashboard = () => import('../components/views/Dashboard/index');
const RegistrarDetail = () => import('../components/views/RegistrarDetail/index');
const MyAccount = () => import('../components/views/MyAccount/index');
const Success = () => import('../components/views/Home/Success');

const routes = [
    {
        path: "/",
        props: true,
        component: Home,
    },

    {
        path: "/success",
        props: true,
        component: Success,
    },

    {
        path: "/login",
        props: true,
        component: Login,
    },

    {
        path: "/forgot-password",
        props: true,
        component: ForgotPassword,
    },

    {
        path: "/forgot-password-sent",
        props: true,
        component: ForgotPasswordSent,
    },

    {
        path: "/set-new-password",
        props: true,
        component: SetNewPassword,
    },

    {
        path: "/new-password-success",
        props: true,
        component: NewPasswordSuccess,
    },

    {
        path: "/dashboard",
        props: true,
        component: Dashboard,
    },

    {
        path: "/registrar-detail",
        props: true,
        component: RegistrarDetail,
    },

    {
        path: "/my-account",
        props: true,
        component: MyAccount,
    },

    // {
    //     path: "*",
    //     component: NotFound,
    // },
];

export default routes;
